---
pageId: concept-journal
title: Czym jest Dziennik
description: Dziennik to oś czasu wszystkiego, co zapisujesz w Samlli — dzień po dniu, z wpisami, notatkami i bocznym panelem statystyk.
category: concepts
order: 2
lang: pl
slug: koncepty/dziennik
updated: 2026-10-16
---

Dziennik to miejsce, gdzie żyją Twoje dni. Pokazuje jeden dzień naraz jako oś czasu wpisów — wszystko, co zapisano, ze wszystkich trackerów, w kolejności zdarzeń. Tu się zapisuje; głębsza analiza mieszka na stronie Statystyk.

## Jak wygląda wpis

Każdy wpis niesie swoją godzinę, tracker, do którego należy, i — zależnie od trackera — wartości metryk, swobodne notatki i tagi. Pierwsza metryka trackera jest główna i renderuje się dużą czcionką; reszta idzie w zwartym rzędzie. Wpisy z integracji przychodzą z tagiem źródła, więc zawsze wiesz, skąd wzięła się wartość.

Wpisy-notatki z trackerów w trybie dziennika pokazują notatkę jako główną treść, a dłuższe teksty chowają się za rozwijanym „więcej".

## Jeden dzień, dwa sposoby czytania

Każdy dzień można oglądać w dwóch trybach, przełączanych z nagłówka dnia:

- **Widok osi czasu** — ściśle chronologicznie, wpis po wpisie.
- **Widok grupowy** — wszystkie wpisy tego samego trackera złożone razem.

Dzisiejszy dzień domyślnie pokazuje oś czasu; dni przeszłe — widok grupowy. Dziennik składa też powtórzenia: sąsiadujące wpisy jednego trackera zwijają się w jedną kartę z licznikiem i zakresem godzin, a tracker z wieloma wpisami w jednym dniu zwija się w całości. Notatki nie są nigdy zwijane.

Dni bez wpisów pozostają uczciwe: pojedynczy pusty dzień to cichy wiersz, a dłuższe przerwy zwijają się w jedną rozwijaną linię z liczbą dni — bez wyrzutów.

## Poruszanie się w czasie

- **Strzałki** — w lewo poprzedni dzień, w prawo następny (do dziś); **t** wraca do dziś.
- **Przejdź do daty** otwiera kalendarz.
- **Przewijanie w dół** dogrywa wcześniejsze dni, aż do pierwszego wpisu, jaki kiedykolwiek powstał — Dziennik mówi wprost, kiedy docierasz do początku.

Wybrana data żyje w adresie URL, więc każdy dzień można dodać do zakładek albo podesłać linkiem.

## Boczny panel statystyk

Obok osi czasu siedzi zwarty panel z bieżącym tygodniem (albo ostatnimi 7 dniami — wybór jest zapamiętywany): **Dni z wpisami**, **Wpisy** i **Aktywne trackery**, plus sekcja **Aktywność** z małym wykresem słupkowym per tracker, linkującym do jego strony.

## Historia i plany

W planie Free Dziennik przewija się 90 dni wstecz; pełna historia jest bezpiecznie przechowywana, a Pro odblokowuje całość. Po perspektywy tygodniowe, miesięczne i roczne idź na stronę Statystyk — tam mieszkają szerokie widoki.
